export type MedicationStatus = "active" | "discontinued" | "paused";

export interface Medication {
  id: string;
  userId: string;
  displayName: string | null;
  productId: string | null;
  resolvedInns: string[];
  dosage: string | null;
  status: MedicationStatus;
  notes: string | null;
  startedAt: string | null;
  stoppedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateMedicationRequest {
  displayName?: string;
  productId?: string;
  activeIngredients?: string[];
  dosage?: string;
  status?: MedicationStatus;
  notes?: string;
  startedAt?: string;
  stoppedAt?: string;
}

export interface UpdateMedicationRequest {
  displayName?: string;
  productId?: string;
  activeIngredients?: string[];
  dosage?: string;
  status?: MedicationStatus;
  notes?: string;
  startedAt?: string;
  stoppedAt?: string;
}

export function getMedicationDisplayName(medication: Pick<Medication, "displayName" | "resolvedInns">): string {
  const displayName = medication.displayName?.trim();
  if (displayName) return displayName;

  const resolvedInns = medication.resolvedInns
    .map((inn) => inn.trim())
    .filter(Boolean);

  return resolvedInns.join(" + ");
}

export function getMedicationSourcePayload(
  medication: Pick<Medication, "displayName" | "productId" | "resolvedInns">
): Pick<UpdateMedicationRequest, "displayName" | "productId" | "activeIngredients"> {
  if (medication.productId) {
    return { productId: medication.productId };
  }

  const activeIngredients = medication.resolvedInns
    .map((inn) => inn.trim())
    .filter(Boolean);

  return {
    ...(medication.displayName?.trim()
      ? { displayName: medication.displayName.trim() }
      : {}),
    activeIngredients: activeIngredients,
  };
}
